import { AbstractControl } from "@angular/forms";

export function CheckUrl(control: AbstractControl) {
	if (control.value) {
		let reg = /^(?:https?:\/\/(?:www\.)?|www\.)[a-z0-9]+(?:[-.][a-z0-9]+)*\.[a-z]{2,5}(?::[0-9]{1,5})?(?:\/\S*)?$/
		if (!control.value.match(reg)) {
			return {
				'invalidUrl': true
			}
		}
	}
	return null
}



// WEBPACK FOOTER //
// ./src/app/services/validators/check-url.validator.ts